import React from 'react';
import { toast } from "react-toastify";
import { useMutation, useQueryClient } from 'react-query';
import { 
  BASE_CACHEKEY_MAP,
  deletePitchSection,
} from "./queries";
import { PortalizedModalContext } from "./../../components/PortalizedModal";
import { renderRailsErrors } from '../../utils/rails_error_parser';

export default function DeleteSectionButton({pitchableType, pitchableId, sectionId, sectionType}) {
  const queryClient = useQueryClient();
  const confirmationModal = React.useContext(PortalizedModalContext);

  const deletePitchSectionMutation = useMutation(
    deletePitchSection,
    {
      onSuccess: () => {
        toast.success("Pitch section deleted.")
        queryClient.invalidateQueries(
          [BASE_CACHEKEY_MAP[pitchableType], pitchableId],
          {
            exact: true
          }
        )
      },
      onError: (error) => {
        toast.error("Pitch section delete failed.")
        renderRailsErrors(error)
      },
      onSettled: () => {
        confirmationModal.closeModal();
      }
    }
  )

  const showConfirmationModal = () => {
    confirmationModal.setModalContent(
      null,
      <div>
        <div className="px-3">
          <p>Are you sure you want to delete section?</p>
        </div>
        <div className="p-3 text-right">
          <button className="btn btn-dark rounded-0 px-3"
            onClick={() => {
              deletePitchSectionMutation.mutate({section_id: sectionId, type: sectionType})
            }}
          >
            Yes, delete section
          </button>
        </div>
      </div>
    )
    confirmationModal.openModal()
  }

  if (!sectionId) return null;

  return (
    <>
      <button type='button'
        className="mx-3 btn btn-outline-dark rounded-0"
        onClick={showConfirmationModal}>delete Section</button>
    </>
  );
}